<template>
    <ContainerLayout page="0">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 v-if="!loading" class="nav-link mb-0 text-dark font-weight-bold">
                            {{ product ? product.current_name : $route.meta.title }}
                        </h6>
                        <div v-if="loading" class="nav-link mb-0 text-dark font-weight-bold">
                            <div class="skeleton-title"></div>
                        </div>
                    </li>
                </div>
                <div class="navbar-nav ml-auto">
                    <NavbarNotification :loading="loading" />
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div class="content px-1">
            <div class="pt-0">
                <div v-if="product && product.custom && product.custom.length > 0" class="card mb-4 mx-lg-2 p-2"
                    style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2); cursor: pointer; display: flex; flex-direction: column; justify-content: space-between;">
                    <div v-for="(item, index) in product.custom" :key="index" class="row d-flex m-2 pb-1">
                        <div class="mr-3">
                            <small style="font-weight: 600;">
                                {{ $t(item['name']) }} <sup class="text-danger">*</sup>
                            </small>
                        </div>
                        <div class="mr-3">
                            <small style="font-weight: 600;">:</small>
                        </div>
                        <div class="ml-auto flex-grow-1">
                            <input v-if="item['type'] == 'string'" type="text" class="form-control form-control-sm"
                                :placeholder="$t(item['name'])" :id="item['id'] + '_' + index" />
                            <input v-if="item['type'] == 'number'" type="number" class="form-control form-control-sm"
                                min="0" :placeholder="$t(item['name'])" :id="item['id'] + '_' + index" />
                        </div>
                    </div>
                </div>
                <div class="w-100 row mx-0">
                    <div v-for="(item, index) in product_details" :key="index"
                        class="col-lg-4 col-md-6 col-sm-12 col-12 mb-4 px-0 px-md-2">
                        <div class="h-100 card-container">
                            <div class="h-100 w-100 card" @click.prevent="selectCard(item)"
                                style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); cursor: pointer; display: flex; flex-direction: column; justify-content: space-between;">
                                <div class="h-100 my-2 mx-3 pb-2">
                                    <div class="h-100 row">
                                        <div class="col-9">
                                            <div class="d-flex flex-column justify-content-start align-items-start">
                                                <small style="font-weight: 600;">
                                                    {{ item.detail_label ?? item.product.current_name }}
                                                </small>
                                                <small class="text-main" style="font-weight: 700; font-size: 13px;">
                                                    {{ item.price_formatted }}
                                                </small>
                                                <div>
                                                    <div class="badge badge-main mr-1" style="opacity: 0;">-</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="h-100 col-3">
                                            <div class="h-100 d-flex justify-content-end align-items-center">
                                                <img :src="product.image_url" style="width: auto; height: 30px;">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-1">
                                    <div class="d-flex align-items-center px-2 py-1">
                                        <img :src="product.provider.image_url" class="img-fluid mr-1"
                                            style="width: 25px; height: auto;">
                                        <p class="mb-0" style="font-weight: 500; font-size: 10px;">
                                            {{ product.provider.name }}
                                        </p>
                                        <div class="ml-auto d-flex align-items-center">
                                            <font-awesome-icon icon="chevron-right" class="text-main ml-2"
                                                style="font-size: 13px;"></font-awesome-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vue-bottom-sheet ref="modalDetail" :swipeable="false" :rounded="true" :overlay-click-close="false"
            max-height="80vh">
            <div id="modal-main" style="height: 80vh; max-height: 80vh;">
                <div v-if="selected_product_detail">
                    <div id="modal-body">
                        <div style="overflow-y: auto; height: 100%;">
                            <div class="w-100 d-flex justify-content-center align-items-center">
                                <div class="d-flex align-items-center"
                                    style="border-radius: 0px 0px 6px 6px; border: 2px solid rgba(0,0,0,.125); border-top: none; padding: 5px 15px;">
                                    <div class="rounded-circle bg-white d-flex justify-content-center align-items-center mr-2"
                                        style="min-width: 22px; min-height: 22px; border: 1px solid #275D93; padding: 2px;">
                                        <img :src="product.provider.image_url" class="img-fluid"
                                            style="width: 22px; height: auto; max-height: 22px;" />
                                    </div>
                                    <div class="d-flex flex-column">
                                        <small class="text-muted" style="font-weight: 500; font-size: 9px;">
                                            {{ $t('Product by') }}
                                        </small>
                                        <small style="font-weight: 500; font-size: 10px;">
                                            {{ product.provider.name }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="w-100 d-flex flex-column justify-content-start align-items-start px-4 py-3">
                                <small style="font-weight: 600;">{{ selected_product_detail.detail_label ??
                                    selected_product_detail.product.current_name }}</small>
                                <small class="text-main" style="font-weight: 700; font-size: 13px;">
                                    {{ selected_product_detail.price_formatted }}
                                </small>
                                <small
                                    v-if="selected_product_detail.api_response && selected_product_detail.api_response['data']"
                                    class="mt-4" style="font-weight: 500;">
                                    {{ $t('Information') }}
                                </small>
                                <div v-if="selected_product_detail.api_response_formatted" class="w-100"
                                    style="font-size: 12px;">
                                    <div v-for="(item, index) in selected_product_detail.api_response_formatted"
                                        :key="index" class="w-100 d-flex mb-1">
                                        <div>
                                            {{ $t(item['name']) }}
                                        </div>
                                        <div class="ml-auto text-right">
                                            {{ item['value'] }}
                                        </div>
                                    </div>
                                </div>
                                <small class="mt-4" style="font-weight: 500;">
                                    {{ $t('Description') }}
                                </small>
                                <small style="font-size: 12px;">
                                    {{ product.current_description ?? '-' }}
                                </small>
                                <div v-if="product.show_recommendation" class="mt-4 w-100">
                                    <small style="font-weight: 500;">
                                        {{ $t('Additional Bundles') }}
                                    </small>
                                    <div class="w-100 d-flex flex-row justify-content-start align-items-center mt-2"
                                        style="overflow-x: auto; overflow-y: hidden; white-space: nowrap;">
                                        <div v-for="(item, index) in product.product_addons" :key="index"
                                            class="card mr-2 mb-3 mt-1 h-100"
                                            style="width: 150px !important; flex-shrink: 0; min-height: 100px; border-radius: 0.25rem; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);"
                                            :style="selected_product_addons.includes(item) ? 'border: 1.5px solid #275D93;' : 'border: 1.5px solid rgba(0,0,0,.125)'">
                                            <div>
                                                <small class="text-muted mx-2" style="font-weight: 500; font-size: 10px;">
                                                    {{ item.product_detail.product.product_category.current_name }}
                                                </small>
                                                <hr class="mt-1 mb-0">
                                            </div>
                                            <div class="card-body p-2">
                                                <div class="w-100 d-flex justify-content-center align-items-center"
                                                    style="height: 40px;">
                                                    <img :src="item.product_detail.product.image_url" class="img-fluid"
                                                        style="width: auto; height: 40px;">
                                                </div>
                                                <div
                                                    class="w-100 d-flex flex-column justify-content-center align-items-start pt-2">
                                                    <small class="mt-1 w-100"
                                                        style="font-weight: 500; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: start;">
                                                        {{ item.product_detail.product.current_name }}
                                                    </small>
                                                    <small v-if="item.original_price <= item.price" class="text-main"
                                                        style="font-weight: 500; font-size: 12px;">
                                                        {{ item.original_price_formatted }}
                                                    </small>
                                                    <small v-if="item.original_price > item.price" class="text-secondary"
                                                        style="font-weight: 500; font-size: 9px; text-decoration: line-through;">
                                                        {{ item.original_price_formatted }}
                                                    </small>
                                                    <small v-if="item.original_price > item.price" class="text-main mb-1"
                                                        style="font-weight: 500; font-size: 12px;">
                                                        {{ item.price_formatted }}
                                                    </small>
                                                    <div v-if="item.product_detail.type != 'onetime'"
                                                        class="badge badge-outline badge-main mt-1"
                                                        style="font-weight: 500; font-size: 10px;">
                                                        {{ item.product_detail.current_name }}
                                                    </div>
                                                    <div v-if="item.is_recommended"
                                                        class="badge-custom badge-outlined badge-warning mt-1"
                                                        style="font-weight: 500; font-size: 10px;">
                                                        {{ $t('Recommended') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="modal-footer" class="w-100 d-flex flex-column card-footer p-2"
                                                style="align-self: flex-end;">
                                                <span v-if="selected_product_addons.includes(item)"
                                                    class="badge badge-outline badge-danger ml-auto p-1"
                                                    style="font-weight: 500; font-size: 10px; cursor: pointer; height: 19.5px;"
                                                    @click.prevent="removeAddonFromCart(item)">
                                                    {{ $t('Remove') }}
                                                </span>
                                                <span v-else class="badge badge-main ml-auto p-1"
                                                    style="font-weight: 500; font-size: 10px; cursor: pointer; height: 19.5px;"
                                                    @click.prevent="selectAddon(item)">
                                                    + {{ $t('Add') }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-price" class="flex-column"
                        :style="selected_product_addons.length > 0 ? 'display: flex; transition: 0.5s;' : 'display: none; transition: 0.5s;'">
                        <div class="w-100 d-flex justify-content-center align-items-center">
                            <div class="d-flex align-items-center mt-1"
                                style="border-radius: 6px 6px 0px 0px; border: 2px solid rgba(0,0,0,.125); border-bottom: none; padding: 5px 15px; width: 80%;">
                                <span class="badge badge-outline badge-main p-1 mt-1"
                                    style="font-weight: 500; height: 19.5px;">
                                    + {{ selected_product_addons.length }} {{ selected_product_addons.length > 1 ?
                                        $t('Bundles') : $t('Bundle') }}
                                </span>
                                <div class="ml-auto">
                                    <small class="text-main" style="font-weight: 700; font-size: 15px;">
                                        {{ addon_price_formatted }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-footer" class="w-100 d-flex flex-column card-footer">
                        <div class="w-100 d-flex justify-content-end align-items-center">
                            <div class="d-flex flex-column">
                                <small style="font-weight: 700;">
                                    {{ $t('Total') }}
                                </small>
                                <small class="text-main" style="font-weight: 700; font-size: 15px;">
                                    {{ total_price_formatted }}
                                </small>
                            </div>
                            <div class="ml-auto">
                                <button class="btn btn-sm btn-main" @click.prevent="addToCart()"
                                    style="border-radius: 10px; width: 100px;">
                                    + {{ $t('Cart') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="px-4 py-3">
                    <label class="text-main font-weight-bold">{{ $t('Please select a product first!') }}</label>
                </div>
            </div>
        </vue-bottom-sheet>
        <vue-bottom-sheet ref="modalAddonDetail" :swipeable="false" :rounded="true" max-height="80vh">
            <div id="modal-main-addon" style="height: 80vh; max-height: 80vh;">
                <div v-if="product_addon">
                    <div id="modal-body-addon">
                        <div style="overflow-y: auto; height: 100%;">
                            <div style="overflow-y: auto; height: 100%;">
                                <div class="w-100 d-flex justify-content-center align-items-center">
                                    <div class="d-flex align-items-center"
                                        style="border-radius: 0px 0px 6px 6px; border: 2px solid rgba(0,0,0,.125); border-top: none; padding: 5px 15px;">
                                        <div class="rounded-circle bg-white d-flex justify-content-center align-items-center mr-2"
                                            style="min-width: 22px; min-height: 22px; border: 1px solid #275D93; padding: 2px;">
                                            <img :src="product_addon.product_detail.product.provider.image_url"
                                                class="img-fluid" style="width: 22px; height: auto; max-height: 22px;" />
                                        </div>
                                        <div class="d-flex flex-column">
                                            <small class="text-muted" style="font-weight: 500; font-size: 9px;">
                                                {{ $t('Product by') }}
                                            </small>
                                            <small style="font-weight: 500; font-size: 10px;">
                                                {{ product_addon.product_detail.product.provider.name }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100 d-flex flex-column justify-content-start align-items-start px-4 py-3">
                                    <small style="font-weight: 600; font-size: 10px;">{{
                                        product_addon.product_detail.product.product_category.current_name
                                    }}</small>
                                    <small style="font-weight: 600; font-size: 15px;">{{
                                        product_addon.product_detail.product.current_name
                                    }}</small>
                                    <small v-if="product_addon.original_price <= product_addon.price" class="text-main"
                                        style="font-weight: 500; font-size: 15px;">
                                        {{ product_addon.original_price_formatted }}
                                    </small>
                                    <small v-if="product_addon.original_price > product_addon.price"
                                        class="text-secondary mt-1"
                                        style="font-weight: 500; font-size: 10px; text-decoration: line-through;">
                                        {{ product_addon.original_price_formatted }}
                                    </small>
                                    <small v-if="product_addon.original_price > product_addon.price" class="text-main mb-1"
                                        style="font-weight: 500; font-size: 15px;">
                                        {{ product_addon.price_formatted }}
                                    </small>
                                    <div>
                                        <div v-if="product_addon.product_detail.type != 'onetime'" class="badge badge-main">
                                            {{ product_addon.product_detail.current_name }}
                                        </div>
                                    </div>
                                    <small class="mt-4" style="font-weight: 500;">
                                        {{ $t('Description') }}
                                    </small>
                                    <small style="font-size: 12px;">
                                        {{ product_addon.product_detail.product.current_description ?? '-' }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-footer-addon" class="w-100 d-flex flex-column card-footer">
                        <div class="w-100 d-flex justify-content-end align-items-center">
                            <div class="d-flex flex-column">
                                <small style="font-weight: 700;">
                                    {{ $t('Total') }}
                                </small>
                                <small class="text-main" style="font-weight: 700; font-size: 15px;">
                                    {{ product_addon.price_formatted }}
                                </small>
                            </div>
                            <div class="ml-auto">
                                <button class="btn btn-sm btn-main" @click.prevent="addAddonToCart()"
                                    style="border-radius: 10px; width: 100px;">
                                    + {{ $t('Add') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-bottom-sheet>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../../ContainerLayout.vue";
import NavbarNotification from "../../NavbarNotification.vue";
import ProductService from "@/services/product.service";
import CartService from "@/services/cart.service";
import { VueBottomSheet } from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { ref } from "vue";

export default {
    name: "ProductDetailItem",
    components: {
        ContainerLayout,
        NavbarNotification,
        VueBottomSheet,
    },
    data() {
        return {
            loading: false,
            product_category: null,
            product: null,
            product_details: [],
            selected_product_detail: null,
            product_addon: null,
            selected_product_addons: [],
            first_load_product: false,
            first_load_addon: false,
            showed_addon_price: false,
            selected_branch: null,
        };
    },
    setup() {
        const modalDetail = ref(null);
        const openModalDetail = () => {
            modalDetail.value.open();
        };
        const closeModalDetail = () => {
            modalDetail.value.close();
        };

        const modalAddonDetail = ref(null);
        const openModalAddonDetail = () => {
            modalAddonDetail.value.open();
        };
        const closeModalAddonDetail = () => {
            modalAddonDetail.value.close();
        };

        return {
            modalDetail,
            openModalDetail,
            closeModalDetail,
            modalAddonDetail,
            openModalAddonDetail,
            closeModalAddonDetail,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
        currentBranch() {
            return localStorage.getItem('branch') ? JSON.parse(localStorage.getItem('branch')) : null;
        },

        addon_price_formatted() {
            let total = 0;
            this.selected_product_addons.forEach((addon) => {
                total += parseFloat(addon.price);
            });
            let formatter = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            });
            let total_string = formatter.format(total);
            if (total_string.includes(",00")) {
                total_string = total_string.replace(",00", "");
            }
            return total_string;
        },

        total_price_formatted() {
            let total = 0;
            if (this.selected_product_detail) {
                total += parseFloat(this.selected_product_detail.price);
            }
            this.selected_product_addons.forEach((addon) => {
                total += parseFloat(addon.price);
            });
            let formatter = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            });
            let total_string = formatter.format(total);
            if (total_string.includes(",00")) {
                total_string = total_string.replace(",00", "");
            }
            return total_string;
        },
    },
    created() {
        if (!this.$route.query.id) {
            this.$router.push("/");
        } else {
            if (!this.$route.query.type) {
                this.$router.push("/");
            } else {
                let decrypted = this.$decryptString(this.$route.query.type, 'encryptKey');
                if (decrypted == null || (decrypted != "company" && decrypted != "personal")) {
                    this.$router.push("/");
                } else {
                    this.loading = true;
                    let loader = this.$loading.show();

                    this.type = decrypted;
                    if (this.type == 'company') {
                        this.selected_branch = this.currentBranch;
                        let location_id = this.currentBranch ? this.currentBranch.location_id : null;

                        ProductService
                            .get(this.$route.query.id, location_id)
                            .then((response) => {
                                this.loading = false;
                                loader.hide();

                                if (response.data.status == "success") {
                                    this.product = response.data.data;
                                    this.product_details = response.data.data.active_product_details;
                                } else {
                                    this.$vueAlert.alert(response.data.message, null, 'error').then(() => {
                                        this.goBack();
                                    });
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                loader.hide();

                                let errorMessage = this.$t('An error occurred');
                                if (error.response) {
                                    if (error.response.status == 401) {
                                        this.$store.dispatch("auth/logout");
                                        this.$router.push('/login');
                                        return; // Exit the function after handling 401
                                    }

                                    // Check if the message is available in the error response
                                    if (error.response.data && error.response.data.message) {
                                        errorMessage = error.response.data.message;
                                    } else if (error.response.statusText) {
                                        // Fallback to statusText if message is not available
                                        errorMessage = error.response.statusText;
                                    }
                                } else if (error.message) {
                                    // Fallback to error.message if response is not available
                                    errorMessage = error.message;
                                }

                                this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                                    this.goBack();
                                });
                            });
                    }
                }
            }
        }
    },
    methods: {
        goBack() {
            if (this.product) {
                this.$router.push({
                    name: "Product Detail",
                    query: {
                        id: this.product.product_category_id,
                        type: this.$encryptString(this.type, 'encryptKey'),
                    },
                });
            } else {
                this.$router.push("/");
            }
        },

        selectCard(item) {
            this.loading = true;
            let loader = this.$loading.show();

            this.product_addon = null;
            this.first_load_addon = false;
            if (this.selected_product_addons.length > 0) {
                this.selected_product_addons = [];
                if (this.showed_addon_price) {
                    this.showed_addon_price = false;
                    let modalBodyHeight = document.getElementById("modal-body").offsetHeight;
                    document.getElementById("modal-body").style.height = (modalBodyHeight + 40) + "px";
                }
            }

            let data = {
                id: item.id,
            }

            let isEmpty = false;
            if (this.product.custom && this.product.custom.length > 0) {
                let custom = [];
                for (let index = 0; index < this.product.custom.length; index++) {
                    let column = this.product.custom[index];
                    let value = document.getElementById(column.id + '_' + index).value;
                    if (value == null || value === "") {
                        this.loading = false;
                        loader.hide();
                        this.$vueAlert.alert(this.$t("Please fill all the required fields!"), null, 'error');
                        isEmpty = true;
                        break;
                    }
                    let custom_item = {
                        id: column.id,
                        value: value,
                    }
                    custom.push(custom_item);
                }
                data.custom_value = custom;
            }

            if (isEmpty == false) {
                ProductService
                    .getDetailByDetailId(data)
                    .then((response) => {
                        this.loading = false;
                        loader.hide();
                        if (response.data.status == "success") {
                            this.selected_product_detail = response.data.data;
                            if (this.selected_product_detail.api_response && this.selected_product_detail.api_response['data'] == null) {
                                this.$vueAlert.alert(this.$t(this.selected_product_detail.api_response['message']), null, 'error');
                            } else {
                                this.openModalDetail();

                                if (!this.first_load_product) {
                                    this.first_load_product = true;

                                    setTimeout(() => {
                                        let bottomSheetPan = document.getElementsByClassName("bottom-sheet__pan")[0];
                                        while (bottomSheetPan.firstChild) {
                                            bottomSheetPan.removeChild(bottomSheetPan.firstChild);
                                        }
                                        bottomSheetPan.classList.add("d-flex", "align-items-center", "h-auto", "pt-2", "pb-0");

                                        let closeButtonWrapper = document.createElement("div");
                                        closeButtonWrapper.classList.add("d-flex", "w-100", "px-2", "pb-2");
                                        closeButtonWrapper.style.borderBottom = "2px solid #e0e0e0";

                                        let closeButton = document.createElement("div");
                                        closeButton.classList.add(
                                            "badge-custom",
                                            "badge-outlined",
                                            "badge-dark",
                                        );
                                        // closeButton.style.position = "absolute";
                                        closeButton.style.left = "10px";
                                        closeButton.style.top = "10px";
                                        closeButton.style.cursor = "pointer";
                                        closeButton.style.backgroundColor = "transparent";
                                        closeButton.style.border = "none";
                                        closeButton.style.fontSize = "22px";
                                        closeButton.style.fontWeight = "500";
                                        closeButton.innerHTML = 'x';

                                        let detailText = document.createElement("span");
                                        detailText.innerHTML = this.$t("Product Detail");
                                        detailText.style.marginLeft = "10px";
                                        detailText.style.fontSize = "16px";
                                        detailText.style.fontWeight = "700";

                                        // Append the detailText element to closeButton
                                        closeButton.appendChild(detailText);
                                        closeButton.addEventListener("click", () => {
                                            this.closeModalDetail();
                                        });

                                        closeButtonWrapper.appendChild(closeButton);
                                        bottomSheetPan.appendChild(closeButtonWrapper);

                                        let bottomSheetCardHeight = document.getElementsByClassName("bottom-sheet__card")[0].offsetHeight;
                                        let bottomSheetPanHeight = document.getElementsByClassName("bottom-sheet__pan")[0].offsetHeight;
                                        document.getElementById("modal-main").style.height = (bottomSheetCardHeight - bottomSheetPanHeight) + "px";

                                        let modalMainHeight = document.getElementById("modal-main").offsetHeight;
                                        // let modalFooterHeight = document.getElementById("modal-footer").offsetHeight;
                                        let modalFooterHeight = 68;
                                        document.getElementById("modal-body").style.height = (modalMainHeight - modalFooterHeight) + "px";
                                    }, 10);
                                }
                            }
                        } else {
                            this.$vueAlert.alert(response.data.message, null, 'error');
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        loader.hide();

                        let errorMessage = this.$t('An error occurred');
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("auth/logout");
                                this.$router.push('/login');
                                return; // Exit the function after handling 401
                            }

                            // Check if the message is available in the error response
                            if (error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            } else if (error.response.statusText) {
                                // Fallback to statusText if message is not available
                                errorMessage = error.response.statusText;
                            }
                        } else if (error.message) {
                            // Fallback to error.message if response is not available
                            errorMessage = error.message;
                        }

                        this.$vueAlert.alert(errorMessage, null, 'error');
                    });
            }
        },

        selectAddon(item) {
            this.product_addon = item;
            this.openModalAddonDetail();

            if (!this.first_load_addon) {
                this.first_load_addon = true;

                setTimeout(() => {
                    let bottomSheetPan = document.getElementsByClassName("bottom-sheet__pan")[1];
                    while (bottomSheetPan.firstChild) {
                        bottomSheetPan.removeChild(bottomSheetPan.firstChild);
                    }
                    bottomSheetPan.classList.add("d-flex", "align-items-center", "h-auto", "pt-2", "pb-0");

                    let closeButtonWrapper = document.createElement("div");
                    closeButtonWrapper.classList.add("d-flex", "w-100", "px-2", "pb-2");
                    closeButtonWrapper.style.borderBottom = "2px solid #e0e0e0";

                    let closeButton = document.createElement("div");
                    closeButton.classList.add(
                        "badge-custom",
                        "badge-outlined",
                        "badge-dark",
                    );
                    // closeButton.style.position = "absolute";
                    closeButton.style.left = "10px";
                    closeButton.style.top = "10px";
                    closeButton.style.cursor = "pointer";
                    closeButton.style.backgroundColor = "transparent";
                    closeButton.style.border = "none";
                    closeButton.style.fontSize = "22px";
                    closeButton.style.fontWeight = "500";
                    closeButton.innerHTML = 'x';

                    let detailText = document.createElement("span");
                    detailText.innerHTML = this.$t("Bundle Detail");
                    detailText.style.marginLeft = "10px";
                    detailText.style.fontSize = "16px";
                    detailText.style.fontWeight = "700";

                    // Append the detailText element to closeButton
                    closeButton.appendChild(detailText);
                    closeButton.addEventListener("click", () => {
                        this.closeModalAddonDetail();
                    });

                    closeButtonWrapper.appendChild(closeButton);
                    bottomSheetPan.appendChild(closeButtonWrapper);

                    let bottomSheetCardHeight = document.getElementsByClassName("bottom-sheet__card")[1].offsetHeight;
                    let bottomSheetPanHeight = document.getElementsByClassName("bottom-sheet__pan")[1].offsetHeight;
                    document.getElementById("modal-main-addon").style.height = (bottomSheetCardHeight - bottomSheetPanHeight) + "px";

                    let modalMainHeight = document.getElementById("modal-main-addon").offsetHeight;
                    // let modalFooterHeight = document.getElementById("modal-footer").offsetHeight;
                    let modalFooterHeight = 68;
                    document.getElementById("modal-body-addon").style.height = (modalMainHeight - modalFooterHeight) + "px";
                }, 10);
            }
        },

        addToCart() {
            this.loading = true;
            let loader = this.$loading.show();

            let product_addon_ids = [];
            this.selected_product_addons.forEach((item) => {
                product_addon_ids.push(item.id);
            });

            let location_id = null;
            let branch_id = null;
            if (this.type == 'company') {
                location_id = this.selected_branch.location_id;
                branch_id = this.selected_branch.id;
            }

            this.closeModalDetail();
            let cart = {
                user_id: this.currentUser.id,
                product_detail_id: this.selected_product_detail.id,
                quantity: 1,
                product_addon_ids: product_addon_ids,
                custom_value: this.selected_product_detail.custom_value,
                api_response: this.selected_product_detail.api_response,
                location_id: location_id,
                branch_id: branch_id,
            };
            CartService
                .store(cart)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    if (response.data.status == "success") {
                        this.$vueAlert.fire({
                            title: null,
                            text: this.$t('Product has been successfully added to cart!'),
                            type: 'success',
                            showConfirmButton: true,
                            showCancelButton: true,
                            reverseButtons: true,
                            confirmButtonText: this.$t('Pay Now'),
                            cancelButtonText: this.$t('Continue Shopping'),
                            confirmButtonColor: '#275D93',
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: 'btn btn-main',
                                cancelButton: 'btn btn-outline-main mr-2',
                            },
                        }).then((result) => {
                            if (result.value) {
                                let data = response.data.data;
                                let cart_ids = [];
                                cart_ids.push(data.id);
                                let encrypted = this.$encryptString(JSON.stringify(cart_ids), 'encryptKey');
                                this.$router.push({
                                    name: "Purchase Detail",
                                    query: {
                                        data: encrypted,
                                    },
                                });
                            }
                        });
                        document.activeElement.blur();
                    } else {
                        // this.openModalDetail();
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();
                    // this.openModalDetail();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },

        addAddonToCart() {
            this.selected_product_addons.push(this.product_addon);
            this.closeModalAddonDetail();

            if (this.selected_product_addons.length > 0) {
                if (!this.showed_addon_price) {
                    this.showed_addon_price = true;
                    let modalBodyHeight = document.getElementById("modal-body").offsetHeight;
                    document.getElementById("modal-body").style.height = (modalBodyHeight - 40) + "px";
                }
            }
        },

        removeAddonFromCart(item) {
            let index = this.selected_product_addons.indexOf(item);
            this.selected_product_addons.splice(index, 1);

            if (this.selected_product_addons.length == 0) {
                if (this.showed_addon_price) {
                    this.showed_addon_price = false;
                    let modalBodyHeight = document.getElementById("modal-body").offsetHeight;
                    document.getElementById("modal-body").style.height = (modalBodyHeight + 40) + "px";
                }
            }
        },

        formatName(name) {
            if (!name) return '';
            const length = name.length;
            if (length <= 4) {
                return name;
            }
            const firstThree = name.substr(0, 4).toUpperCase();
            const remaining = 'X'.repeat(length - 4);
            return `${firstThree}${remaining}`;
        },

        formatDaya(daya) {
            if (!daya) return '';
            const dayaString = String(daya);
            const length = dayaString.length;
            if (length >= 9) {
                return dayaString;
            }
            const zerosToAdd = 9 - length;
            const paddedDaya = '0'.repeat(zerosToAdd) + dayaString;
            return paddedDaya;
        },
    }
};
</script>
  
<style scoped>
.skeleton-title {
    margin-top: 0.25rem !important;
    width: 100px;
    height: 19.2px;
    background-color: #e6e6e6;
    border-radius: 5px;
}
</style>